import { render, staticRenderFns } from "./ScratchOff.vue?vue&type=template&id=e9d6f590&"
import script from "./ScratchOff.vue?vue&type=script&lang=js&"
export * from "./ScratchOff.vue?vue&type=script&lang=js&"
import style0 from "./ScratchOff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports